import { useTranslation } from 'react-i18next';
import { ErrorBoundarySuspense } from '@/components/error-boundary-suspense';
import { GET_PURCHASE_ORDER_KEY } from '@/keys';
import { PurchaseOrderMainContent } from './purchase-order-main-content';
import { PurchaseOrderMainSkeleton } from './purchase-order-main-skeleton';

type PurchaseOrderMainProps = {
  id: string;
};

export function PurchaseOrderMain({ id }: PurchaseOrderMainProps) {
  const { t } = useTranslation('purchaseOrder');

  return (
    <ErrorBoundarySuspense
      errorFallbackWrapper={
        <div className='flex h-full w-full items-center justify-center p-4' />
      }
      loadingFallback={<PurchaseOrderMainSkeleton />}
      message={t('Unable to load purchase order')}
      queryKey={[...GET_PURCHASE_ORDER_KEY, id]}
    >
      <PurchaseOrderMainContent id={id} />
    </ErrorBoundarySuspense>
  );
}
